import { API_BASE_URL } from './config';

const BASE_URL = `${API_BASE_URL}/accounts`;
const apiClient = {
  getAllSummaries: async () => {
    const response = await fetch(`${BASE_URL}/get_all_summaries`);
    if (!response.ok) throw new Error('Failed to fetch summaries');
    return response.json();
  },

  createSummary: async (data) => {
    const response = await fetch(`${BASE_URL}/create_new_month_entry`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Failed to create summary');
    return response.json();
  },

  updateSummary: async (summaryMonth, data) => {
    const response = await fetch(`${BASE_URL}/update_summary/${summaryMonth}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Failed to update summary');
    return response.json();
  },

  deleteSummary: async (summaryMonth) => {
    const response = await fetch(`${BASE_URL}/delete_entire_month_summary/${summaryMonth}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Failed to delete summary');
    return response.json();
  },

  addDailyEntry: async (summaryMonth, dailyData) => {
    const response = await fetch(`${BASE_URL}/add_newDaily_entry_to_specific_month/${summaryMonth}/daily`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dailyData),
    });
    if (!response.ok) throw new Error('Failed to add daily entry');
    return response.json();
  },

  updateDailyEntry: async (summaryMonth, date, dailyData) => {
    const response = await fetch(`${BASE_URL}/update_daily_entry_by_date_inSpecific_month/${summaryMonth}/daily/${date}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ dailyData }),
    });
    if (!response.ok) throw new Error('Failed to update daily entry');
    return response.json();
  },

  deleteDailyEntry: async (summaryMonth, date) => {
    const response = await fetch(`${BASE_URL}/delete_entry_by_date/${summaryMonth}/${date}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Failed to delete daily entry');
    return response.json();
  },

  getSummaryByMonth: async (summaryMonth) => {
    const response = await fetch(`${BASE_URL}/get_summary_by_month/${summaryMonth}`);
    if (!response.ok) throw new Error('Failed to fetch summary');
    return response.json();
  },
};

export default apiClient;